import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, SelectItem } from 'primeng/primeng';
import { StoreCampaignService } from '../../services/store/stores-campaign.service';

@Component({
  selector: 'kv-article-choice',
  template: `
    <div class="ui-g-12 dashboard card card-w-title">
      <div class="ui-g-12 ui-grid-row">
        {{'products.select_product' | translate}}
      </div>
      <form (ngSubmit)="this.onNextClick()" #categoryChoiceForm="ngForm">
        <div class="ui-g-12 ui-grid-row">
          <p-dropdown [style]="{'width':'100%'}" [filter]="true" filterBy="label" [options]="this.categories" (onChange)="this.onChangeCategory($event)"></p-dropdown>
        </div>
        <div class="ui-g-12 ui-grid-row">
          <p-autoComplete name="autocomplete" [(ngModel)]="this.selectedArticles" [suggestions]="this.suggestedArticles"
                          (completeMethod)="this.onSearchItem($event)" [multiple]="true"
                          (onSelect)="this.checkLength($event)"
                          (onDropdownClick)="this.onSearchItem($event)"
                          [minLength]="2" field="descrizione_estesa"></p-autoComplete>
        </div>
      </form>
    </div>
  `,
  styles: [`
    .kvRoundedButton {
      border: none;
      width: 100%;
      height: 40px;
      border: none;
      background-color: #20417b !important;
      color: #ffffff !important;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 1.11;
      border-radius: 100px;
    }

    .kvRoundedButton:hover {
      border: #20417b 1px solid !important;
      background-color: #ffffff !important;
      color: #20417b !important;
    }

    .kvRoundedButton:disabled {
      border: gray 1px solid;
      background-color: white !important;
      color: gray !important;
    }

    .kvRoundedButton:disabled:hover {

      border: gray 1px solid !important;
      background-color: white !important;
      color: gray !important;
    }
  `]
})

export class ArticleChoiceComponent implements OnInit, OnChanges {

  onNextClick() {
    // TODO
  }

  @Input() maxSelectableItems: number = -1;
  @Output() onNext: EventEmitter<any> = new EventEmitter();

  categories: SelectItem[];
  selectedCategory: SelectItem;
  selectedArticles: any[];
  suggestedArticles: any[];
  messages: any;

  constructor(private srvStore: StoreCampaignService,
              private srvNotify: MessageService,
              private translation: TranslateService
  ) {

    this.translation.get(['products.article_title','products.max_article_length']).subscribe( res => {
      this.messages = {
        title: res['products.article_title'],
        article_length: res['products.max_article_length']
      }
    })
    this.selectedCategory = null;
    this.categories = [{
      label: "",
      value: "uncategorized"
    }];
    this.srvStore.getCategories().subscribe(res => {
      this.srvStore.categories.forEach(c => {
        this.categories.push({
          label: c.descrizione_subsettore,
          value: c.descrizione_subsettore
        });
      })
    });
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  onSearchItem(event) {
    if (event.query != "") {
      this.suggestedArticles =
        this.srvStore.flat_articles.filter((value, index, obj) => {
          return value.descrizione_articolo.toUpperCase().indexOf(event.query.toUpperCase()) != -1;
        });
    }
    else {
      this.suggestedArticles = [];
      Object.assign(this.suggestedArticles, this.srvStore.flat_articles);
    }
    this.suggestedArticles.forEach(a => {
      a.descrizione_estesa =
        a.codice_articolo.toString().concat(" - ").concat(a.descrizione_articolo)
          .concat(" (")
          .concat(a.descrizione_reparto).concat(" > ")
          .concat(a.descrizione_categoria).concat(" > ")
          .concat(a.descrizione_subcategoria)
          .concat(")");
    })
  }

  checkLength(event) {
    if (this.maxSelectableItems != -1 && this.selectedArticles.length > this.maxSelectableItems) {
      this.srvNotify.add({
        severity: 'warning',
        summary: this.messages.title,
        detail: this.messages.article_length.concat(" (").concat(this.maxSelectableItems.toString()).concat(")")
      });
      this.selectedArticles.splice(this.maxSelectableItems);
    }
    this.onNext.emit(this.selectedArticles);

  }

  onChangeCategory(item: SelectItem) {
    this.selectedCategory = item;
    this.srvStore.getCategoryArticles(item.value).subscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/products/article-choice.component.ts